import React, { PropsWithChildren } from 'react';

import { StyleSheet, View } from 'react-native';

import { CardModal } from 'components/card-modal';
import { ModalHeaderProps } from 'components/card-modal-header';

import { useProductDetailCardModalStyles } from './use-product-detail-card-modal-styles';

type ProductDetailCardModalProps = PropsWithChildren<
  ModalHeaderProps & {
    testID?: string;
    analyticsEvent?: string | null;
    standardPadding?: boolean;
    alwaysShowHeader?: boolean;
    alwaysHideHeader?: boolean;
    webAnimate?: boolean;
    noDesktopWebMaxWidth?: boolean;
    disableGlobalAppModals?: boolean;
    hasInternalFooter?: boolean;
    keyboardAwareFooter?: boolean;
    isFullScreen?: boolean;
  }
>;

export function ProductDetailCardModal({
  children,
  ...cardModalProps
}: ProductDetailCardModalProps) {
  const productDetailStyles = useProductDetailCardModalStyles();

  const modal = <CardModal {...cardModalProps}>{children}</CardModal>;

  if (!productDetailStyles) {
    return modal;
  }

  return <View style={[styles.shell, productDetailStyles]}>{modal}</View>;
}

const styles = StyleSheet.create({
  shell: {
    flex: 1,
  },
});
